import { createReducer, on } from '@ngrx/store';
import { ConsigneesActions, ConsigneeListItem, ConsigneeDetail } from './consignees.actions';

export interface ConsigneesState {
  items: ConsigneeListItem[];
  totalElements: number;
  loading: boolean;
  saving: boolean;
  error: any;
  lastSavedUuid: string | null;
  selectedEntity: ConsigneeDetail | null;
  loadingDetails: boolean;
  deleting: boolean;
  deleteSuccess: boolean;
}

export const initialState: ConsigneesState = {
  items: [],
  totalElements: 0,
  loading: false,
  saving: false,
  error: null,
  lastSavedUuid: null,
  selectedEntity: null,
  loadingDetails: false,
  deleting: false,
  deleteSuccess: false,
};

export const consigneesReducer = createReducer(
  initialState,
  on(ConsigneesActions.loadAll, (state) => ({ ...state, loading: true })),
  on(ConsigneesActions.loadAllSuccess, (state, { content, totalElements }) => ({
    ...state,
    items: content,
    totalElements,
    loading: false,
  })),
  on(ConsigneesActions.loadAllFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  on(ConsigneesActions.save, (state) => ({ ...state, saving: true, error: null })),
  on(ConsigneesActions.saveSuccess, (state, { entity }) => ({
    ...state,
    saving: false,
    lastSavedUuid: entity.uuid,
    // Prepend to items if not there or update
    items: [entity, ...state.items.filter(i => i.uuid !== entity.uuid)],
  })),
  on(ConsigneesActions.saveFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error,
  })),
  on(ConsigneesActions.clearSaveState, (state) => ({
    ...state,
    saving: false,
    error: null,
    lastSavedUuid: null,
  })),

  on(ConsigneesActions.loadDetails, (state) => ({ ...state, loadingDetails: true, selectedEntity: null, error: null })),
  on(ConsigneesActions.loadDetailsSuccess, (state, { entity }) => ({
    ...state,
    selectedEntity: entity,
    loadingDetails: false,
  })),
  on(ConsigneesActions.loadDetailsFailure, (state, { error }) => ({
    ...state,
    error,
    loadingDetails: false,
  })),

  on(ConsigneesActions.delete, (state) => ({ ...state, deleting: true, deleteSuccess: false, error: null })),
  on(ConsigneesActions.deleteSuccess, (state, { uuid }) => ({
    ...state,
    deleting: false,
    deleteSuccess: true,
    items: state.items.filter(i => i.uuid !== uuid),
    totalElements: Math.max(0, state.totalElements - 1),
  })),
  on(ConsigneesActions.deleteFailure, (state, { error }) => ({
    ...state,
    deleting: false,
    error,
  })),
  on(ConsigneesActions.clearDeleteState, (state) => ({
    ...state,
    deleting: false,
    deleteSuccess: false,
    error: null,
  }))
);
